var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { NotificationIcon } from '../notification-icon';
import { Heading } from '../heading';
import { avatarStyle, decorativeHeaderStyle, headerStyle } from './styles';
import { useDialog } from './dialog-context';
function Header(_a) {
    var _b = _a.mode, mode = _b === void 0 ? 'plain' : _b, _c = _a.variant, variant = _c === void 0 ? 'info' : _c, customIconOverride = _a.customIconOverride, children = _a.children, restProps = __rest(_a, ["mode", "variant", "customIconOverride", "children"]);
    var _d = useDialog(), headerId = _d.headerId, alignCenter = _d.alignCenter;
    function renderIcon() {
        return customIconOverride ? (
        // Auto-set size of custom icon
        cloneElement(customIconOverride, { size: 'large' })) : (_jsx(NotificationIcon, { variant: variant, size: "large" }));
    }
    return (_jsxs(_Fragment, { children: [mode === 'decorative' && (_jsx("div", __assign({ css: decorativeHeaderStyle({ variant: variant }) }, { children: _jsx("span", __assign({ css: avatarStyle({ variant: variant }) }, { children: renderIcon() })) }))), _jsx(Heading, __assign({ id: headerId, css: headerStyle({ mode: mode, alignCenter: alignCenter }) }, restProps, { children: children }))] }));
}
export default Header;
